<template>
  <v-menu
    v-model="menu"
    offset-y
    absolute
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <div
        v-on="on"
        :style="`
          position: absolute;
          left: ${tagRect.x}px;
          top: ${tagRect.y}px;
        `" 
      >
        <div
          class="tag"
          :style="`
            width: ${tagRect.w}px;
            height: ${tagRect.h}px;`"
          @mouseover="onMouseOver"
          @mouseleave="onMouseLeave"
        ></div>
        <div
          v-if="memberChip && hover"
          :style="`
            position: absolute;
            bottom: -36px;
            width: 500%;
            left: ${tagRect.w / 2}px;
            transform: translateX(-50%);
            z-index: 1;
            text-align: center;
          `"
        >
          <v-chip pill class="white">
            <v-avatar left>
              <img :src="memberChip.picture" class="primary">
            </v-avatar>
            {{ memberChip.name }}
          </v-chip>
        </div>
      </div>
    </template>
    <v-card v-if="editMode" max-width="360px" class="px-4 pt-4">
      <FbMemberAutocomplete
        v-model="tag.member"
        clearable />
      <v-card-actions>
        <v-spacer />
        <v-btn text
          class="error--text"
          @click="deleteTag"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import FbMemberMixin from '../mixins/fb-member'
import FbMemberAutocomplete from '../components/FbMemberAutocomplete'

import { fbMemberName } from '../utils'

export default {
  name: 'FbPictureTag',
  mixins: [FbMemberMixin],
  components: {
    FbMemberAutocomplete
  },
  props: {
    tag: Object,
    editMode: Boolean,
    sizeRatio: {
      type: Object,
      default: () => ({ x: 1, y: 1 })
    }
  },
  data() {
    return {
      hover: false,
      menu: false,
      memberChip: null
    }
  },
  computed: {
    tagRect() {
      return {
        x: this.tag.x * this.sizeRatio.x,
        y: this.tag.y * this.sizeRatio.y,
        w: this.tag.size * this.sizeRatio.x,
        h: this.tag.size * this.sizeRatio.y
      }
    }
  },
  methods: {
    updateMemberChip() {
      this.memberChip = null
      const { member } = this.memberFromRef(this.tag.member) || {}

      if (member) {
        this.memberChip = {
          name: fbMemberName(member),
          picture: member.profilePicture
        }
      }
    },
    deleteTag() {
      this.$emit('delete', this.tag);
      this.menu = false
    },
    onMouseOver() {
      this.updateMemberChip()
      this.hover = true
    },
    onMouseLeave() {
      this.hover = false
    }
  }
}
</script>

<style scoped>
.tag {
  background: #00000009;
  border: 3px solid #ffffff99;
}

.tag:hover {
  background: #00000011;
  border: 3px solid #ffffff;
}
</style>